import fastInitializeComponent from 'Shared/fast-react-initialize';
import TextComponent from './text_component';

fastInitializeComponent('TextComponent', TextComponent);
